import {
  AUTHORIZED_VIEW_NAMES,
  RESOURCES_TABS,
  CATALOG_TABS,
  CUSTOMER_TABS,
  DEFAULT_SCREENS,
  COMPANIES_TABS,
  LEAD_TABS,
  CUSTOMER_SCREENS,
  PROPOSAL_CATALOG_TABS,
  MY_NETWORK_TABS,
  SERVICE_REQUEST_TABS
} from './routesConstants';

export const DASHBOARD_TAB = {
  icon: 'dashboard',
  position: 1,
  route: AUTHORIZED_VIEW_NAMES.DASHBOARD,
  text: 'Dashboard'
};

export const CALENDAR_TAB = {
  icon: 'calendar',
  position: 2,
  route: AUTHORIZED_VIEW_NAMES.CALENDAR,
  text: 'Calendar'
};

export const PROJECT_TAB = {
  icon: 'project',
  position: 3,
  route: DEFAULT_SCREENS.PROJECTS,
  text: 'Project'
};

export const ASSIGNMENTS_TAB = {
  icon: 'resources',
  position: 4,
  route: AUTHORIZED_VIEW_NAMES.ASSIGNMENTS,
  text: 'Assignments'
};

export const CUSTOMER_TAB = {
  children: [
    {
      route: CUSTOMER_TABS.NEW_CUSTOMER,
      text: 'Create'
    },
    {
      route: CUSTOMER_TABS.ALL,
      text: 'All'
    },
    {
      route: CUSTOMER_TABS.CONTACTS,
      text: 'Contacts'
    },
    {
      route: CUSTOMER_TABS.PROSPECTS,
      text: 'Prospects'
    },
    {
      route: CUSTOMER_TABS.CLIENTS,
      text: 'Clients'
    }
  ],
  icon: 'customer',
  position: 5,
  route: '',
  text: 'CRM'
};

export const LEAD_TAB = {
  children: [
    {
      route: LEAD_TABS.NEW,
      text: 'Create'
    },
    {
      route: LEAD_TABS.LEADS,
      text: 'Leads'
    }
  ],
  icon: 'lead',
  position: 6,
  route: '',
  text: 'Lead'
};

export const CHAT_TAB = {
  icon: 'chat',
  position: 7,
  route: DEFAULT_SCREENS.CHATS,
  text: 'Chat'
};

export const TIMESHEET = {
  icon: 'timesheet',
  position: 8,
  route: AUTHORIZED_VIEW_NAMES.TIMESHEET,
  text: 'Timesheet'
};

export const MY_NETWORK_TAB = {
  children: [
    {
      route: MY_NETWORK_TABS.PARTNERS,
      text: 'Partners'
    },
    {
      route: MY_NETWORK_TABS.INVITATIONS,
      text: 'Invitations'
    },
    {
      route: MY_NETWORK_TABS.REQUIREMENTS,
      text: 'Requirements'
    }
  ],
  icon: 'resources',
  position: 9,
  route: 'my-network/partners',
  text: 'My Network'
};

export const INSPECTIONS_TAB = {
  icon: 'documents',
  position: 16,
  route: 'inspections',
  text: 'Inspections'
};

export const MY_SITES_TAB = {
  icon: 'pin',
  position: 17,
  route: 'my-sites',
  text: 'My Sites'
};

export const MY_VISITS_TAB = {
  icon: 'timesheet',
  position: 18,
  route: 'my-visits',
  text: 'My Visits'
};

export const MY_SCHEDULE_TAB = {
  icon: 'calendar',
  position: 19,
  route: 'my-schedule',
  text: 'My Schedule'
};

export const SERVICE_REQUESTS_TAB = {
  icon: 'pending-file',
  position: 15,
  route: 'service-requests/board',
  text: 'Service Requests'
};

export const DOCUMENTS_TAB = {
  icon: 'documents',
  position: 9,
  route: '',
  text: 'Documents'
};

export const CATALOG_TAB = {
  children: [
    {
      route: CATALOG_TABS.SERVICE,
      text: 'Services'
    },
    {
      route: CATALOG_TABS.TASK,
      text: 'Tasks'
    },
    {
      route: CATALOG_TABS.SKILLS,
      text: 'Skills'
    },
    {
      route: CATALOG_TABS.CATEGORIES,
      text: 'Categories'
    },
    {
      route: CATALOG_TABS.CHECKLISTS,
      text: 'Checklists'
    },
    {
      route: CATALOG_TABS.MATERIALS,
      text: 'Materials'
    }
  ],
  icon: 'catalog',
  position: 10,
  route: '',
  text: 'Service Catalog'
};

export const PROPOSAL_CATALOG_TAB = {
  children: [
    {
      route: PROPOSAL_CATALOG_TABS.CONTRACT_HEADER,
      text: 'Contract Header'
    },
    {
      route: PROPOSAL_CATALOG_TABS.TERMS_AND_CONDITIONS,
      text: 'Terms and conditions'
    },
    {
      route: CATALOG_TABS.PROPOSAL_MESSAGES,
      text: 'Proposal Messages'
    }
  ],
  icon: 'project',
  position: 11,
  route: '',
  text: 'Proposal Catalog'
};

export const CATALOG_SUPERUSER_TAB = {
  children: [
    {
      route: CATALOG_TABS.SERVICE,
      text: 'Services'
    },
    {
      route: CATALOG_TABS.TASK,
      text: 'Tasks'
    },
    {
      route: CATALOG_TABS.SKILLS,
      text: 'Skills'
    },
    {
      route: CATALOG_TABS.CATEGORIES,
      text: 'Categories'
    },
    {
      route: CATALOG_TABS.CHECKLISTS,
      text: 'Checklist'
    },
    {
      route: CATALOG_TABS.MATERIALS,
      text: 'Materials'
    },
    {
      route: CATALOG_TABS.PROPOSAL_MESSAGES,
      text: 'Proposal Messages'
    },
    {
      route: CATALOG_TABS.WIDGETS,
      text: 'Widgets'
    },
    {
      route: CATALOG_TABS.CALCULATOR_DEFAULTS,
      text: 'Calculator Defaults'
    }
  ],
  icon: 'catalog',
  position: 10,
  route: '',
  text: 'Catalog'
};

export const RESOURCES_TAB = {
  children: [
    {
      route: RESOURCES_TABS.INVITATIONS,
      text: 'Invitations'
    },
    {
      route: RESOURCES_TABS.USERS,
      text: 'Users'
    }
  ],
  icon: 'resources',
  position: 12,
  route: '',
  text: 'Resources'
};

export const RESOURCES_OPT_TAB = {
  children: [
    {
      route: RESOURCES_TABS.INVITATIONS,
      text: 'Invitations'
    },
    {
      route: RESOURCES_TABS.USERS,
      text: 'Users'
    }
  ],
  icon: 'resources',
  position: 12,
  route: '',
  text: 'Resources'
};

export const RESOURCES_ADMIN_TAB = {
  children: [
    {
      route: RESOURCES_TABS.INVITATIONS,
      text: 'Invitations'
    },
    {
      route: RESOURCES_TABS.USERS,
      text: 'Users'
    },
    {
      route: RESOURCES_TABS.REQUESTS,
      text: 'Requests'
    }
  ],
  icon: 'resources',
  position: 12,
  route: '',
  text: 'Resources'
};

export const COMPANIES_TAB = {
  children: [
    {
      route: COMPANIES_TABS.INVITATIONS,
      text: 'Invitations'
    },
    {
      route: COMPANIES_TABS.COMPANIES,
      text: 'Companies'
    }
  ],
  icon: 'company',
  position: 13,
  route: '',
  text: 'Companies'
};

export const COMPANY_SETTINGS = {
  icon: 'settings',
  position: 14,
  route: AUTHORIZED_VIEW_NAMES.COMPANY_SETTINGS,
  text: 'Settings'
};

export const CUSTOMER_DASHBOARD_TAB = {
  icon: 'dashboard',
  position: 1,
  route: CUSTOMER_SCREENS.DASHBOARD,
  text: 'Dashboard'
};
export const CUSTOMER_PROJECT_TAB = {
  icon: 'project',
  position: 2,
  route: CUSTOMER_SCREENS.PROJECTS,
  text: 'Projects'
};

export const CUSTOMER_INVOICES_TAB = {
  icon: 'calculator',
  position: 3,
  route: CUSTOMER_SCREENS.INVOICES,
  text: 'Invoices'
};

export const CUSTOMER_INFORMATION_TAB = {
  icon: 'resources',
  position: 4,
  route: CUSTOMER_SCREENS.INFORMATION,
  text: 'Information'
};

export const CUSTOMER_PROPOSAL_TAB = {
  icon: 'project',
  position: 5,
  route: CUSTOMER_SCREENS.PROPOSALS,
  text: 'Proposals'
};

export const CUSTOMER_SERVICE_REQUESTS_TAB = {
  icon: 'lead',
  position: 6,
  route: CUSTOMER_SCREENS.SERVICE_REQUESTS,
  text: 'Service Requests'
};

export default {
  // ASSIGNMENTS_TAB,
  CALENDAR_TAB,
  CATALOG_SUPERUSER_TAB,
  CATALOG_TAB,
  CHAT_TAB,
  COMPANIES_TAB,
  COMPANY_SETTINGS,
  CUSTOMER_TAB,
  DOCUMENTS_TAB,
  INSPECTIONS_TAB,
  LEAD_TAB,
  MY_NETWORK_TAB,
  MY_SCHEDULE_TAB,
  MY_SITES_TAB,
  MY_VISITS_TAB,
  PROJECT_TAB,
  PROPOSAL_CATALOG_TAB,
  RESOURCES_ADMIN_TAB,
  RESOURCES_OPT_TAB,
  RESOURCES_TAB,
  SERVICE_REQUESTS_TAB,
  TIMESHEET
};
